module.exports = __webpack_public_path__ + "static/img/a4.74d9b0bd.png";